import { render, staticRenderFns } from "./SipSessionCallsList.vue?vue&type=template&id=733183dd&"
import script from "./SipSessionCallsList.vue?vue&type=script&lang=js&"
export * from "./SipSessionCallsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports